import React from "react";
import "./ConfirmStyle.css"; // Стили для модального окна
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

function ConfirmMessage({ message, onConfirm, onCancel }) {
  const { t } = useTranslation();
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <p>{message}</p>
        <div className="modal-buttons">
          <motion.button
            whileTap={{ scale: 0.95 }}
            transition={{ duration: 0.1 }}
            onClick={onConfirm}
          >
            {t("Yes")}
          </motion.button>
          <motion.button
            whileTap={{ scale: 0.95 }}
            transition={{ duration: 0.1 }}
            onClick={onCancel}
          >
            {t("No")}
          </motion.button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmMessage;
